import React from 'react';
import CheckInOutDialog from './CheckInOutDialog';
import AddItemDialog from './AddItemDialog';
import EditItemDialog from './EditItemDialog';
import ConfirmDeleteDialog from './ConfirmDeleteDialog';
import QRCodeDialog from './QRCodeDialog';
import QRScannerDialog from './QRScannerDialog';
import SettingsDialog from './SettingsDialog';
import ItemDetailDialog from './ItemDetailDialog';
import ImportDialog from './ImportDialog';

const DialogManager: React.FC = () => {
  return (
    <>
      <CheckInOutDialog />
      <AddItemDialog />
      <EditItemDialog />
      <ConfirmDeleteDialog />
      <QRCodeDialog />
      <QRScannerDialog />
      <SettingsDialog />
      <ItemDetailDialog />
      <ImportDialog />
    </>
  );
};

export default DialogManager;